import { has, unset } from 'lodash';

const root = (typeof self === 'object' && self.self === self && self) ||
  (typeof global === 'object' && global.global === global && global) ||
  this;

export function setGlobal(key, value) {
  root[key] = value;
  return value;
}

export function getGlobal(key, notSetValue = undefined) {
  if (has(root, key)) {
    return root[key];
  }

  return notSetValue;
}

export function clearGlobal(key) {
  return unset(root, key);
}



// WEBPACK FOOTER //
// ./utils/global.js